import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { PRODUCT_FIELDS } from './dashboardUtils';

async function save(workbook, filename) {
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer], { type: 'application/octet-stream' }), filename);
}

function addSheet(wb, name, title, period, headers, rows) {
  const ws = wb.addWorksheet(name);
  ws.addRow([title]).font = { bold: true, size: 14 };
  ws.mergeCells(1, 1, 1, Math.max(headers.length, 2));
  ws.addRow([`Period: ${period}`]).font = { bold: true };
  ws.mergeCells(2, 1, 2, Math.max(headers.length, 2));
  ws.addRow(headers).font = { bold: true };
  rows.forEach((r) => ws.addRow(r));
  ws.columns.forEach((c) => { c.width = 14; });
}

export async function exportMaintenance(records, period, kpis) {
  const wb = new ExcelJS.Workbook();
  addSheet(wb, 'Summary', 'Maintenance Dashboard', period, ['Metric', 'Value'], kpis.map((k) => [k.label, k.value]));
  addSheet(wb, 'Records', 'Maintenance Records', period,
    ['S/N', 'Assign Date', 'Work Type', 'Department', 'Machine', 'Assigned To', 'Status'],
    records.map((r, i) => [i + 1, r.AssignDate || '', r.WorkType || '', r.Department || '', r.Machine || '', r.AssignedTo || '', r.CompleteDate ? 'Closed' : 'Open'])
  );
  await save(wb, `Maintenance_Dashboard_${period.replace(/\s+/g, '_')}.xlsx`);
}

export async function exportWarranty(supply, warranty, rejection, period, kpis) {
  const wb = new ExcelJS.Workbook();
  const hdr = ['S/N', 'YearMonth', ...PRODUCT_FIELDS];
  addSheet(wb, 'Summary', 'Warranty Dashboard', period, ['Metric', 'Value'], kpis.map((k) => [k.label, k.value]));
  addSheet(wb, 'Supply', 'Supply', period, hdr, supply.map((r, i) => [i + 1, r.YearMonth || '', ...PRODUCT_FIELDS.map((f) => r[f] ?? '')]));
  addSheet(wb, 'Warranty', 'Warranty', period, hdr, warranty.map((r, i) => [i + 1, r.YearMonth || '', ...PRODUCT_FIELDS.map((f) => r[f] ?? '')]));
  addSheet(wb, 'Warranty %', 'Warranty %', period, hdr, rejection.map((r, i) => [i + 1, r.YearMonth || '', ...PRODUCT_FIELDS.map((f) => r[f] ?? '')]));
  await save(wb, `Warranty_Dashboard_${period.replace(/\s+/g, '_')}.xlsx`);
}

export async function exportMain(maintenance, supply, warranty, period, kpis) {
  const wb = new ExcelJS.Workbook();
  const hdr = ['S/N', 'YearMonth', ...PRODUCT_FIELDS];
  addSheet(wb, 'Summary', 'Command Centre Dashboard', period, ['Metric', 'Value'], kpis.map((k) => [k.label, k.value]));
  addSheet(wb, 'Maintenance', 'Maintenance', period,
    ['S/N', 'Assign Date', 'Work Type', 'Department', 'Status'],
    maintenance.map((r, i) => [i + 1, r.AssignDate || '', r.WorkType || '', r.Department || '', r.CompleteDate ? 'Closed' : 'Open'])
  );
  addSheet(wb, 'Supply', 'Supply', period, hdr, supply.map((r, i) => [i + 1, r.YearMonth || '', ...PRODUCT_FIELDS.map((f) => r[f] ?? '')]));
  addSheet(wb, 'Warranty', 'Warranty', period, hdr, warranty.map((r, i) => [i + 1, r.YearMonth || '', ...PRODUCT_FIELDS.map((f) => r[f] ?? '')]));
  await save(wb, `Main_Dashboard_${period.replace(/\s+/g, '_')}.xlsx`);
}
